export function Currency({
  data,
  price,
  card,
  dealPrice,
  discountedPrice,
  TypeCurrency,
  isFlash,
  buyerServiceFee,
}) {
  return (
    <>
      {data?.isFlashSale === false ? (
        <>
          {!card.discountedPrice ? (
            <>
              {card?.status != "Pending" &&
              card?.status != "Live" &&
              card?.status != "Rejected" ? (
                <div className="sold-price montserrat-font">
                  {new Intl.NumberFormat().format(price)} {TypeCurrency}
                </div>
              ) : (
                <>
                  {new Intl.NumberFormat().format(price)} {TypeCurrency}
                </>
              )}
            </>
          ) : (
            <>
              {card?.status != "Pending" &&
              card?.status != "Live" &&
              card?.status != "Rejected" ? (
                <div className="sold-price montserrat-font">
                  <div className=" montserrat-font">
                    {new Intl.NumberFormat().format(discountedPrice)}{" "}
                    {TypeCurrency}
                  </div>
                </div>
              ) : (
                <>
                  <div className=" montserrat-font">
                    {new Intl.NumberFormat().format(discountedPrice)}{" "}
                    {TypeCurrency}
                  </div>
                </>
              )}
            </>
          )}
        </>
      ) : (
        <>
          {card?.isInDeal === true && (
            <>
              {data
                ?.filter((data) => data?.id === "offers")
                ?.map((data) => (
                  <>
                    {data?.isFlashSale && (
                      <>
                        <>
                          {isFlash ? (
                            <>
                              {card?.status != "Pending" &&
                              card?.status != "Live" &&
                              card?.status != "Rejected" ? (
                                <div className="sold-price montserrat-font">
                                  <div className=" montserrat-font">
                                    {new Intl.NumberFormat().format(dealPrice)}{" "}
                                    {TypeCurrency}
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <div className=" montserrat-font">
                                    {new Intl.NumberFormat().format(dealPrice)}{" "}
                                    {TypeCurrency}
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <>
                                {!card?.discountedPrice ? (
                                  card?.status != "Pending" &&
                                  card?.status != "Live" &&
                                  card?.status != "Rejected" ? (
                                    <div className="sold-price">
                                      <div className=" montserrat-font">
                                        <div>
                                          {new Intl.NumberFormat().format(
                                            price
                                          )}{" "}
                                          {TypeCurrency}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="montserrat-font">
                                        {new Intl.NumberFormat().format(price)}{" "}
                                        {TypeCurrency}
                                      </div>
                                    </>
                                  )
                                ) : (
                                  <>
                                    {card?.status != "Pending" &&
                                    card?.status != "Live" &&
                                    card?.status != "Rejected" ? (
                                      <div className="sold-price montserrat-font">
                                        <div className="montserrat-font">
                                          {new Intl.NumberFormat().format(
                                            discountedPrice
                                          )}{" "}
                                          {TypeCurrency}
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        <div className=" montserrat-font">
                                          {new Intl.NumberFormat().format(
                                            discountedPrice
                                          )}{" "}
                                          {TypeCurrency}
                                        </div>
                                      </>
                                    )}
                                  </>
                                )}
                              </>
                            </>
                          )}
                        </>
                      </>
                    )}
                  </>
                ))}
            </>
          )}

          {!card.isInDeal && (
            <>
              {!card?.discountedPrice ? (
                card?.status != "Pending" &&
                card?.status != "Live" &&
                card?.status != "Rejected" ? (
                  <div
                    className={` ${
                      buyerServiceFee == "true" ? "" : "sold-price"
                    }`}
                  >
                    <div
                      className={` ${
                        buyerServiceFee == "true" ? "" : "price-mybag"
                      }`}
                    >
                      {new Intl.NumberFormat().format(price)} {TypeCurrency}
                    </div>
                  </div>
                ) : (
                  <>
                    {card?.status != "Pending" &&
                    card?.status != "Live" &&
                    card?.status != "Rejected" ? (
                      <div className="sold-price">
                        <div className="">
                          {new Intl.NumberFormat().format(price)} {TypeCurrency}
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="">
                          {new Intl.NumberFormat().format(price)} {TypeCurrency}
                        </div>
                      </>
                    )}
                  </>
                )
              ) : (
                <>
                  {card?.status != "Pending" &&
                  card?.status != "Live" &&
                  card?.status != "Rejected" ? (
                    <div className="sold-price">
                      <div className="">
                        {new Intl.NumberFormat().format(discountedPrice)}{" "}
                        {TypeCurrency}
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className="">
                        {new Intl.NumberFormat().format(discountedPrice)}{" "}
                        {TypeCurrency}
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
